// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-757f24f2] .el-dialog__body {\n  padding: 16px 32px 0;\n}\n[data-v-757f24f2] .el-dialog__footer {\n  padding-top: 0;\n}", ""]);
// Exports
module.exports = exports;
